// components/LoginScreen.jsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';

function LoginScreen({ username, setUsername, roomId, setRoomId, createRoom, joinRoom, isDarkMode, setIsDarkMode }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background">
      <div className="bg-surface p-8 rounded-xl shadow-lg w-full max-w-md border border-border">
        <h1 className="text-3xl font-bold mb-6 text-center text-text">Willkommen!</h1>
        <div className="mb-4">
          <label htmlFor="username" className="block text-text-light text-sm font-bold mb-2">Dein Benutzername</label>
          <input
            type="text"
            id="username"
            placeholder="Gib deinen Namen ein"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="shadow appearance-none border rounded w-full py-3 px-4 text-text-light leading-tight focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent bg-background"
          />
        </div>
        <div className="mb-6">
          <label htmlFor="roomId" className="block text-text-light text-sm font-bold mb-2">Raum-ID (optional)</label>
          <input
            type="text"
            id="roomId"
            placeholder="Raum-ID zum Beitreten"
            value={roomId}
            onChange={(e) => setRoomId(e.target.value)}
            className="shadow appearance-none border rounded w-full py-3 px-4 text-text-light leading-tight focus:outline-none focus:ring-2 focus://ring-primary focus:border-transparent bg-background"
          />
        </div>
        <div className="flex flex-col gap-4">
          <button
            onClick={createRoom}
            disabled={!username}
            className="bg-primary hover:bg-primary-dark text-white font-bold py-3 px-6 rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-75 transition-colors duration-200"
          >
            Neuen Raum erstellen
          </button>
          <button
            onClick={joinRoom}
            disabled={!username || !roomId}
            className="bg-accent hover:bg-accent-dark text-white font-bold py-3 px-6 rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-accent focus:ring-opacity-75 transition-colors duration-200"
          >
            Raum beitreten
          </button>
        </div>
        <div className="mt-8 text-center">
          <button
            onClick={() => setIsDarkMode(!isDarkMode)}
            className="p-2 rounded-full text-text hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50"
            title="Dark Mode umschalten"
          >
            <FontAwesomeIcon icon={isDarkMode ? faSun : faMoon} size="lg" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default LoginScreen;